import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_LANGUAGES, res.data)
  })
)

export const getLanguage = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_LANGUAGE, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.save(obj).then(res => {
    commit(types.SET_LANGUAGE, res.data.data)
    return res
  })
}

export const toggleStatus = async ({ commit }, id) => {
  await services.toggleStatus(id).then(res => {
    return res
  })
}

export const setDefault = async ({ commit }, id) => {
  await services.setDefault(id).then(res => {
    return res
  })
}

export const updateOrder = async ({ commit }, obj) => {
  await services.updateOrder(obj).then(res => {
    return res
  })
}

export const deleteLanguage = async ({ commit }, id) => {
  await services.deleteLanguage(id).then(res => {
    return res
  })
}
